import { call, put, takeEvery } from "redux-saga/effects";
import { datadogRum } from "@datadog/browser-rum";
import * as api from "../../../api/api";
import { refreshReducersToInitial } from "../../../action";
import { generatePath } from "../../../utilities/RedirectUtils";
import {
  SUBMIT_CALL_OEM_PARTIAL_SAVE_REQUEST,
  submitCallOemPartialSaveSuccess,
  submitCallOemPartialSaveFailed,
} from "../actions";
import { buildCallOemPartialSavePayload } from "../helpers";
import { CallOemPartialSaveRequestPayload } from "../types";

export function* submitCallOemPartialSave(action: {
  type: string;
  payload: CallOemPartialSaveRequestPayload;
}) {
  const { serviceRequestPayload, partnerCode, callId, oemNumber, history, dispatch } = action.payload;
  try {
    const payloadWithCallOemFlag = buildCallOemPartialSavePayload(serviceRequestPayload);
    yield call(api.saveRescueDetails, payloadWithCallOemFlag, partnerCode, "end", history, dispatch);
    datadogRum.addAction("[oemDeflectionTrigger] customer clicked call for oem benefits", {
      callId,
      oemNumber,
    });
    yield put(submitCallOemPartialSaveSuccess());
    yield put(refreshReducersToInitial());
    history.push(generatePath("memberlookup"));
  } catch (error) {
    yield put(submitCallOemPartialSaveFailed(error));
  }
}

export function* watchSubmitCallOemPartialSave() {
  yield takeEvery(SUBMIT_CALL_OEM_PARTIAL_SAVE_REQUEST, submitCallOemPartialSave);
}
